import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { ReportTags } from "./ReportTags";
import type { AdjustmentReportItemDto } from "@/api/dtos";
import type { AdjustmentReportItem } from "./_models/AdjustmentReport";
import { toAdjustmentReportItemFromDto } from "./_transformers/toAdjustmentReportItemFromDto";

/** One adjustment report file, parsed into rows; the name "latest" (LATEST) resolves to the newest file. */
export const getAdjustmentReportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAdjustmentReport: builder.query<AdjustmentReportItem[], string>({
      queryFn: async (name) => {
        try {
          const res = await axios.get<AdjustmentReportItemDto[]>(
            `${backendBase()}/adjustment-reports/${encodeURIComponent(name)}`,
            { headers: { Accept: "application/json" } },
          );
          const rows = res.data.map((x) => toAdjustmentReportItemFromDto(x));
          return { data: rows };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: (_result, _error, name) => [
        { type: ReportTags.AdjustmentReport, id: name },
      ],
    }),
  }),
});

export const getAdjustmentReport = getAdjustmentReportApi.endpoints.getAdjustmentReport;
